
export const IMG_URl = "https://kriechapi.krieshrestaurant.com/storage/";

